//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopScreen from '~/components/TopScreen.vue'
import HowItWorks from '~/components/common/HowItWorkSafetypay.vue'
import FooterTop from '~/components/footer/footerTop.vue'
import DescriptionBlock from '~/components/forCompanies/DescriptionBlock.vue'
import AnimatedLink from '~/components/common/AnimatedLink.vue'
import PaymentDescription from '~/components/common/PaymentDescription.vue'

export default {
  components: {
    TopScreen,
    FooterTop,
    HowItWorks,
    DescriptionBlock,
    AnimatedLink,
    PaymentDescription
  },
  head () {
    return {
      title: this.$t('footer.payment-methods.safetypay').concat(' | Pagsmile '),
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.$t('seo.description')
        }
      ]
    }
  },
  data () {
    return {
      hiw: {
        title: 'safetypay.block1.title',
        subtitle: 'safetypay.block1.subtitle',
        steps: [
          'safetypay.block1.item1',
          'safetypay.block1.item2',
          'safetypay.block1.item3',
          'safetypay.block1.item4'
        ],
        imgs: [
          require('@/assets/img/payment-methods/safetypay/b1-1.png'),
          require('@/assets/img/payment-methods/safetypay/b1-2.png'),
          require('@/assets/img/payment-methods/safetypay/b1-3.png'),
          require('@/assets/img/payment-methods/safetypay/b1-4.png')
        ]
      }
    }
  }
}
